import { render, staticRenderFns } from "./rvpallocation.vue?vue&type=template&id=53f41468"
import script from "./rvpallocation.vue?vue&type=script&lang=js"
export * from "./rvpallocation.vue?vue&type=script&lang=js"
import style0 from "./rvpallocation.vue?vue&type=style&index=0&id=53f41468&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports